// Environment configurations
const localEnvironment = {
  baseUrl: 'http://localhost:8080/api'
};

const devEnvironment = {
  baseUrl: 'https://your-dev-backend.herokuapp.com'
};

const productionEnvironment = {
  baseUrl: import.meta.env.VITE_API_URL || 'https://yetfarrag.com/api'
};

// Function to determine current environment based on URL
const getCurrentEnvironment = () => {
  // Server-side: use env var or default to production
  if (typeof window === 'undefined') {
    return {
      baseUrl: process.env.VITE_API_URL || import.meta.env.VITE_API_URL || 'http://localhost:8080/api'
    };
  }

  const currentUrl = window.location.href;

  if (currentUrl.includes('localhost') || currentUrl.includes('127.0.0.1')) {
    return  productionEnvironment;
  } else if (currentUrl.includes('dev') || currentUrl.includes('development')) {
    return devEnvironment;
  } else if (currentUrl.includes('staging')) {
    return productionEnvironment;
  } else {
    // Default to production for production or unknown environments
    return productionEnvironment;
  }
};

// Export the appropriate environment configuration
export const environment = getCurrentEnvironment();
